import { Tooltip } from 'azure-devops-ui/TooltipEx';
import { IProposedWorkItem } from '../../../types';
import { WorkItemIcon } from './WorkItemIcon';
import React from 'react';
import { Status, Statuses, StatusSize } from 'azure-devops-ui/Status';

export function ProposedWorkItemHeader(wi: IProposedWorkItem) {
  const status = (() => {
    switch (wi.status) {
      case 'Proposed':
        return Statuses.Information;
      case 'Created':
        return Statuses.Success;
    }
  })();

  return (
    <div className='proposed-work-item-header flex-row flex-center h-scroll-hidden'>
      <WorkItemIcon {...wi} />
      <div className='flex-column text-ellipsis'>
        <Tooltip overflowOnly={true}>
          <div className='primary-text text-ellipsis'>{wi.title}</div>
        </Tooltip>
      </div>
      { wi.status == "Created" && <Status {...Statuses.Success} size={StatusSize.m}/>}
    </div>
  );
}
